<template>
  <cf-validated-form
    :disabled="isProcessing"
    name="checkGiftCardBalance"
    @valid-submit="submit"
  >
    <div class="cf-flex cf-flex--column cf-flex--gap-12">
      <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-16">
        <div class="cf-flex cf-flex--grow-1">
          <cf-text-input
            v-model="cardNumber"
            type="text"
            icon-class="fa-credit-card"
            label="Card Number"
            name="cardNumber"
            inputmode="numeric"
            mask="giftCard"
            :validations="{
              required: true
            }"
          />
        </div>

        <div
          v-if="giftCardPinRequired"
          class="cf-flex cf-flex--no-shrink cf-flex--flex-basis-md"
        >
          <cf-text-input
            v-model="pin"
            type="text"
            label="PIN"
            name="pin"
            allowed-characters="0-9a-zA-Z"
            inputmode="numeric"
            :validations="{
              required: true
            }"
          />
        </div>
      </div>

      <button
        class="cf-button cf-button--primary cf-button--lg cf-button--fill"
        :class="{ 'cf-button--loading': isProcessing }"
        type="submit"
      >
        {{ addCtaText }}
      </button>
    </div>
  </cf-validated-form>
</template>


<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';

  import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';
  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'GiftCardBalanceCheck',

    components: {
      CfValidatedForm,
      CfTextInput
    },

    props: {
      addCtaText: {
        type: String,
        default: 'Add Card'
      },
      prefill: {
        type: Object,
        default() {
          return {};
        }
      }
    },

    data() {
      return {
        cardNumber: null,
        isProcessing: false,
        pin: null
      };
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),

      giftCardPinRequired() {
        return this.merchant.defaultPaymentGateway?.methods?.giftCard?.giftCardPinRequired;
      }
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        this.cardNumber = this.prefill.cardNumber;
        this.pin = this.prefill.pin;
      },

      async submit() {
        try {
          this.isProcessing = true;

          const card = await this.$store.dispatch('giftCards/checkCardBalance', {
            cardNumber: this.cardNumber,
            ignoreZeroBalance: true,
            pin: this.pin
          });

          this.$emit('success', card);
        }

        catch (error) {
          errorHandlers.generic(error);
        }

        finally {
          this.isProcessing = false;
        }
      }
    }
  };
</script>
